import { Component } from '@angular/core';
import { ContractModelService } from '../contracts.model.service';

@Component({
  moduleId: module.id,
  templateUrl: 'contracts.objects.component.html',
  providers: []
})

export class ContractsObjectsComponent {

  model: any = {};
  errorMessage: string;

  constructor(private contractModelService: ContractModelService) {
  }

  ngOnInit() {
    this.model = this.contractModelService.getData();
  }

}



// WEBPACK FOOTER //
// ./src/app/components/dashboard/contracts/objects/contracts.objects.component.ts